/** Holt eine anzeigbare Meldung aus einem Axios-/FastAPI-Fehler. */
export const readApiError = (err: unknown, fallback = 'Fehler beim Speichern.'): string => {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail

  if (Array.isArray(detail)) {
    const messages = detail.map((d: { msg?: string }) => d.msg ?? '').filter(Boolean)
    if (messages.length) return messages.join(', ')
  }
  if (typeof detail === 'string' && detail) return detail

  return fallback
}
